module.exports = __webpack_public_path__ + "static/persona_icon-cfc6364f7f58db1aec9da16b810b4469.svg";